var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 43,
    viewBox: "0 0 360 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_768_9",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 360,
    height: 43
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 43,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_768_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.303325 89.8638C2.50495 37.4719 47.2171 -2.12412 99.5641 1.42345L365.016 19.4132L355.319 200.317C352.511 252.708 307.799 292.304 255.452 288.757L84.7827 277.191C32.4357 273.643 -7.72344 228.295 -4.91517 175.903L-0.303325 89.8638Z",
    fill: "#0C4B76"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueRound);
export default __webpack_public_path__ + "static/media/blue-round.277bec13fa06de38fa008409b195e92b.svg";
export { ForwardRef as ReactComponent };